const sectionIdentifiers = {
    weOffer: "we-offer",
    projects: "our-projects",
    careers: "careers",
};

export default sectionIdentifiers;
